setTimeout(() => {
  document.querySelector('.description.heading--nomal')
    ?.classList.add('lazy-loaded');
}, 1500);

document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (e) {
    const button = e.target.closest("ap-wishlistbutton");
    if (!button) return;

    const wishlistSection = document.querySelector("ap-wishlistdisplay");
    const sectionId = wishlistSection?.getAttribute("section-id");

    if (!sectionId) return;

    // Delay to wait for wishlist update
    setTimeout(() => {
      fetch(`${window.location.pathname}?sections=${sectionId}`)
        .then((res) => res.json())
        .then((data) => {
          if (data[sectionId] && wishlistSection) {
            wishlistSection.outerHTML = data[sectionId];
          }
        })
        .catch((err) => {
          console.error("Failed to reload wishlist section", err);
        });
    }, 300);
  });
});



/* ===============================
   Size Chart Modal
================================ */
document.addEventListener('DOMContentLoaded', function () {
  const openBtn = document.querySelector('[data-size-chart-open]');
  const modal = document.getElementById('SizeChartModal');

  if (!openBtn || !modal) return;

  // Open modal
  openBtn.addEventListener('click', function () {
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  });

  // Close modal
  modal.addEventListener('click', function (e) {
    if (
      e.target === modal ||
      e.target.closest('[data-size-chart-close]')
    ) {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });
});

/* ===============================
   Variant Image Sync (KEEP)
================================ */
document.addEventListener('variant:change', function (event) {
  const img = document.getElementById('SizeChartProductImage');
  if (!img || !event.detail || !event.detail.variant) return;

  if (event.detail.variant.featured_image) {
    img.src = event.detail.variant.featured_image.src + '&width=800';
  }
});
